<template lang="pug">
modal(name='addentity', id="editmodal" @before-open="beforeOpen"  transition='pop-up', :width="'720px'", height='720px')
  n-button.closedialog(@click.native="closeModal()") ❌ 
  .mr-auto 
    //span.modaltitle {{ title === '' ? 'Sample' : `${title} Sample`}}
    span.modaltitle Create {{ module ? module : 'Entity' }}
    .card
      .card-body
        .editform
          vue-form(:state="formstate" @submit.prevent="onSubmit")
            fieldset(:disabled="formDisabled" v-if="module === 'Entity'")
              validate(tag="label" :custom="{customValidator: uniqueSampleName}")
                span.title(v-tooltip="'<b>Type of Entity</b><br/>Procedure or Instructions<br/>'")  Type
                multiselect(:options="sampleOptions" v-model="sampleValue" :multiple="false" name="select")
    //.card
      .card-body
        .editform
          vue-form(:state="formstate" @submit.prevent="onSubmit")
            fieldset(:disabled="formDisabled")
              validate(tag="label" :custom="{customValidator: uniqueSampleName}")
                span.title(v-tooltip="'<b>Sample Name</b><br/>name must be unique within your set of samples<br/> no spaces allowed<br/>'")  Sample
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons users_single-02" :disabled="sampleDisabled"  autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.sample" required="" name="sample" placeholder="23&meSample")
                field-messages(name="sample")
                  div.validmsg 
                    i(class="fas fa-check")
                  div.infomsg(slot="required") spaces or duplicate sample names, not allowed
                  div.errmsg(slot="customValidator") not unique or contains spaces
              validate(tag="label") 
                span.title(v-tooltip="'Allow sample to be viewed publicly<br/>default is \"no\"<br/>'") Public
                span.subtext *
                el-switch( v-model="model.public" :disabled="formDisabled" :active-value="1" :inactive-value="0"  active-text="Yes" inactive-text="No" name="public" )
              validate(tag="label")
                span.title(v-tooltip="'<b>Ethnicity</b> of sample<br/>be as specific as possible<br/>if sample has parents/grand-parents of different ethnicities, select the primary ethnicity and provide details in the description field below<br/>'") Ethnicity
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons location_world" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.ethnicity" name="ethnicity" type="" required="" placeholder="Japanese")
              validate(tag="label")
                span.title(v-tooltip="'<b>Country of origin</b><br/>'") Origin
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons location_pin" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.origin" name="origin" type="" required="" placeholder="Japan")
                field-messages(name="origin")
                  div.infomsg(slot="required") country of origin
              validate(tag="label")
                span.title(v-tooltip="'Detail of ethnic background for the sample<br/>This can include specific information about geographic locations, ethnicities of parents/grand-parents, as well as sub-ethnicities'") Description
                fg-input(addon-left-icon="now-ui-icons ui-1_zoom-bold" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.description" name="description" type="" info=true placeholder="All grandparents from Japan")
              validate(tag="label" :custom="{customValidator: validatePeriod}")
                span.title(v-tooltip="`<b>Sample Date</b><br/>approximate age/period of sample<br/>This date refers to the age of the sample <br/>Use current year <b>${new Date().getFullYear()}</b> for recent samples`") Sample Date
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons ui-1_calendar-60" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.age" name="age" type=""  required="" :placeholder="new Date().getFullYear()")
                field-messages(name="age")
                  div.validmsg 
                    i(class="fas fa-check")
                  div.infomsg(slot="required") date of sample, use + for CE, - for BCE
                  div.errmsg(slot="customValidator") valid range {{new Date().getFullYear()}} to -100k
              validate(tag="label" :custom="{customValidator: validateCoords}")
                span.title(v-tooltip="`<b>Scaled Coordinates</b><br/>These are the first of the set of coordinates you received after your raw file was processed<br/><b>Please input just the actual coordinates without the header (PC1, PC2, PC3...)</b>`") Scaled coordinates
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons education_atom" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.coords" name="coords" type="" required="" placeholder="0.112685,0.15436,0.029038,-0.031331,0.031083,-0.011435,-0.015981,-0.020768,-0.002863,0.036629,0.012017,-0.001798,-0.015312,-0.000688,-0.032166,-0.010077,0.021774,-0.004307,0.009804,-0.02001,-0.018842,-0.005193,0.000246,-0.008676,-0.005628")
                field-messages(name="coords")
                  div.validmsg 
                    i(class="fas fa-check")
                  div.infomsg(slot="required") scaled coordinates without header
                  div.errmsg(slot="customValidator") comma separated coordinates "0.112685,..."
              validate(tag="label" :custom="{customValidator: validateCoords}")
                span.title(v-tooltip="`<b>Unscaled Coordinates</b><br/>These are the second of the set of coordinates you received after your raw file was processed<br/><b>Please input just the actual coordinates without the header (PC1, PC2, PC3...)</b>`") Unscaled coordinates
                span.subtext *
                fg-input(addon-left-icon="now-ui-icons education_atom" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.coords2" name="coords2" type="" required="" placeholder="0.0099,0.0152,0.0077,-0.0097,0.0101,-0.0041,-0.0068,-0.009,-0.0014,0.0201,0.0074,-0.0012,-0.0103,-0.0005,-0.0237,-0.0076,0.0167,-0.0034,0.0078,-0.016,-0.0151,-0.0042,0.0002,-0.0072,-0.0047")
                field-messages(name="coords2")
                  div.validmsg 
                    i(class="fas fa-check")
                  div.infomsg(slot="required") un-scaled coordinates without header
                  div.errmsg(slot="customValidator") comma separated coordinates "0.112685,..."
              //n-checkbox(v-model="form.agree")
                | I agree to the terms and
                a(href="#something") conditions
                | .
              .card-footer.text-center
                n-button.addrawdna(v-if="button === 'Add'" type='primary' icon='' round @click.native="feature('upload')"  v-tooltip="'upload raw DNA file<br/>(23&me/FTDNA/Ancestry)'") 
                  i(class="fas fa-upload" style="opacity:1")
                n-button(type="primary" @click.native="onSubmit()" round="" size="lg") 
                  geno-spinner(:loading="running" :text="button" :size="32")
                  //span(:class="{hidden: !running}") {{button}}
                  //geno-spinner(:class="{hidden: running }" :size="64")
</template>
<script>
import { Card, Button, FormGroupInput, Checkbox } from '@/components'
import {
    Switch
} from 'element-ui'
export default {
  name: 'EditSamplesModal',
  props: ['text'],
  components: {
      [Button.name]: Button,
      [Card.name]: Card,
      [Switch.name]: Switch,
      [Checkbox.name]: Checkbox,
          [FormGroupInput.name]: FormGroupInput
            },
  data() { 
    return {
    button: 'OK',
    title: '',
    username: this.$store.getters.get('user').username,
    groupSelect: false,
    sampleValue: null,
    sampleOptions: ['Client', 'Business Line', 'Group', 'Procedure', 'Instructions', 'Program'],
    editsample: false,
    formDisabled: false,
    sampleDisabled: false,
    formstate: {},
    running: false,
		form: { agree: false },
    model : {},
    newSample: {
      public: 0,
      group: 'test',
      sample: 'test',
      ethnicity: 'test',
      description: 'test',
      age: 2019,
      origin: 'test',
      coords: '',
      coords2: '',
    }
    }
  },
  computed: {
    module: function() { return  (this.$store.getters.get('module') ) },
    changes: function() { return  this.$store.getters.get('changes') },
    initData: function() {
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    return data;
    },
  model2: function() {
  return this.initData[0]
  }
  },
  methods: {
    closeModal: function() {
    this.$modal.hide('addentity');
    },
      beforeOpen (event) {
          if ( event.params.action === 'info' || event.params.action === 'edit' ) {
          this.model = this.initData[event.params.index]
          if ( event.params.action === 'info' ) {
          this.button = 'OK'
          this.title = '';
          this.formDisabled = true;
          } else {
          this.title = 'Edit'
          this.button = 'Modify'
          this.formDisabled = false;
          this.sampleDisabled = true;
          }
          } else {
          this.formDisabled = false;
          this.sampleDisabled = false;
          this.button = 'Add'
          this.model = { group: this.username }
          this.title = 'Add'
          }
          },
		feature: function(el) {
            this.$eventBus.$emit('appEvents', {
                exec: 'featureRequest',
                component: 'g25',
                params: el
            })
		},
    onSubmit: function() {
      if(this.formstate.$invalid) {
        // alert user and exit early
            this.$eventBus.$emit('appEvents', {
                exec: 'show',
                component: 'nav',
                params: {
                    title: 'Error',
                    text: 'Please fill in all required fields',
                    class: 'failure'
                }
            })
        return;
      } else {
    var changes = {...this.changes}
    var data = JSON.parse(JSON.stringify(this.$store.getters.get("editSamples")));
    if ( this.model.index >=0 ) {
    this.model.action = 'update'
    data.splice(this.model.index, 1, this.model )
    } else {
    var index = data.length;
    this.model.index = index;
    this.model.action = 'insert'
    data.push(this.model);
    }
    changes[this.model.sample] = this.model
    this.$store.commit('change', { changes: changes })
    this.$store.commit('change', { editSamples: data })
    this.$modal.hide('addentity');
		}
    },
    validatePeriod: function (value) {
    if ( parseInt(value) <= new Date().getFullYear() && parseInt(value) >= -100000 ) {
    return true
    } else {
    return false
    }
    },
    validateCoords: function (value) {
    var coords = value.split(",");
    if ( coords.length !== 25 || coords.findIndex(n => parseInt(n) !== 0) >= 0 ) {
    return false 
    } else {
    return true
    }
    },
  uniqueSampleName: function (value) {
    var index = this.initData.findIndex( sample => sample.sample === value )
		if ( value.indexOf(' ') >= 0 || (index >= 0 && !this.formDisabled && !this.sampleDisabled)) {
		return false
			} else {
    return true
		}
  }
  }
}
</script>
<style>

#app span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #055258;
}

#editmodal ::placeholder {
font-weight: 400;
}

#editmodal fieldset[disabled] .form-control {
background-color: #ffffff;
}

#editmodal input.vf-valid {
color: #096b94;
font-weight: 700;
}
#editmodal input.vf-invalid {
color: brown;
font-weight: 700;
}
#editmodal .form-control[disabled] {
background-color: white;
    color: #999;
        font-size: 1em;
            margin-left: 15px;
                cursor: not-allowed;
                }

#editmodal fieldset[disabled] .btn-primary:disabled {
display: none;
}
.v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline;
    float: right;
    z-index: 9;
}
#app #editmodal .v--modal button.closedialog:hover {
box-shadow: none;
}
#app #editmodal .v--modal button.closedialog:active {
background: #9797971c;
}
span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #0f5579;
}
.infomsg, .validmsg, .errmsg {
font-size: 0.9em;
text-align: left;
padding-left: 20px;
color: #a2a2a2;
}
.errmsg {
color: rgba(255,0,0,0.7);
}
#editmodal .v--modal-box {
margin-top: 0px;
}

#editmodal .fas.fa-check {
color: green;
}

#editmodal .mr-auto {
height: 100%;
}
#editmodal .card {
height: 100%;
}
#editmodal .el-switch {
height: 46px;
padding-bottom: 10px;
}
div.settings {
    display:grid;
    grid-template-columns: max-content max-content;
    grid-gap:5px;
}
div.settings label       { text-align:right; }
div.settings label:after { content: ":"; }
label {
width: 70%;
margin-left: 30%;
}
#editmodal .addrawdna:hover {
    opacity: 1;
    }
#editmodal .addrawdna {
    opacity: 0.7;
    background-color: white !important;
    color: #206096;
    font-size: 16px;
    border: 1px solid #206096;
font-size: 16px;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 8px;
    left: 23px;
box-shadow: none;
z-index: +9;
}
#editmodal span.title {
font-weight: 400;
    padding-top: 8px;
    position: absolute;
    right: 72%;
    text-align: right;
    z-index: 1;
}
#app #editmodal span.subtext {
    font-weight: 400;
    font-size: 20px;
    padding-top: 3px;
    position: absolute;
    width: 30%;
    left: 0px;
    color: brown;
    text-align: right;
}

#app #editmodal .card {
padding: 50px 20px;
}

#editmodal .break>input {
    word-wrap: break-word;
    word-break: break-all;
    height: 80px;
}

#app .editform label {
    width: 70%;
        margin-left: 20%;
        }
        
#app #editmodal .editform span.title {
    font-weight: 400;
    padding-top: 8px;
    position: absolute;
    right: 80%;
    text-align: right;
    z-index: 1;
}

</style>
